import { siteConfig } from "../config/site";

interface DeliveryNoticeProps {
  variant?: "strip" | "card";
}

export function DeliveryNotice({ variant = "card" }: DeliveryNoticeProps) {
  if (variant === "strip") {
    return (
      <aside className="delivery-strip" aria-label="Delivery information">
        <div className="delivery-strip-inner">
          <strong>Delivery information</strong>
          <p>{siteConfig.delivery.uk.notice}</p>
        </div>
      </aside>
    );
  }

  return (
    <div className="delivery-card">
      <span className="delivery-icon" aria-hidden="true">
        ↗
      </span>
      <div>
        <strong>Delivery information</strong>
        <p>{siteConfig.delivery.uk.notice}</p>
      </div>
    </div>
  );
}
